import axios from 'axios';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';

import * as utils from '../utils/utils.js';

import 'dayjs/locale/is.js';

dayjs.extend(utc);

export const updateAttendance = async (attendance_id, value, updatedBy, isFromSocketUpdate = false) => {
    if (!attendance_id) {
        console.warn('attendance_id is not set');
        return;
    }

    const session_url = utils.backendUrl() + '/attendance/' + attendance_id;
    try {
        const response = await axios.patch(
            session_url,
            {
                confirmed: value,
                updated_by: updatedBy,
                timestamp: dayjs.utc().format('YYYY-MM-DD HH:mm:ss'),
                isFromSocketUpdate: isFromSocketUpdate, // Pass flag to backend
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.status === 200) {
            utils.saveLastCreatedUuid(response.data.attendance.attendance_id);
        }
        return response.data;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

export const toggleAllowedAttendance = async (event_id, participant_id) => {
    const session_url = utils.backendUrl() + '/allowed_participant/';
    try {
        const response = await axios.patch(
            session_url,
            {
                participant_id: participant_id,
                event_id: event_id,
                timestamp: dayjs().utc().format('YYYY-MM-DD HH:mm:ss'),
                headers: {
                    'Content-Type': 'application/json',
                },
            },
            {
                withCredentials: true,
            }
        );
        return response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

export const createGuestSeat = async (sessionId, guestName) => {
    if (!sessionId) {
        console.warn('sessionId is not set');
        return;
    }

    const url = utils.backendUrl() + '/attendance';
    try {
        const response = await axios.post(
            url,
            {
                session_id: sessionId,
                confirmed: true,
                is_guest: true,
                timestamp: dayjs().utc().format('YYYY-MM-DD HH:mm:ss'),
                name: guestName,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.status === 200 || response.status === 201) {
            utils.saveLastCreatedUuid(response.data.attendance.attendance_id);
        }
        return response.data;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
